import { ClientEvent } from '@udemy/event-tracking';
export class LabsResumeBannerContinueClickEvent extends ClientEvent {
  constructor({
    labId,
    labInstanceUuid,
    labVertical,
    labCompletionMode
  }) {
    super('LabsResumeBannerContinueClickEvent');
    this.labId = void 0;
    this.labInstanceUuid = void 0;
    this.labVertical = void 0;
    this.labCompletionMode = void 0;
    this.labId = labId;
    this.labInstanceUuid = labInstanceUuid;
    this.labVertical = labVertical;
    this.labCompletionMode = labCompletionMode;
  }
}
//# sourceMappingURL=labs-resume-banner-continue-click-event.js.map